var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "upgrade-needed",
        "show-footer": false,
        "show-title": false,
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "upgrade-svg" }, [_c("CreditCardNeeded")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("Kredi Kartı Zorunlu")]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            "\n            Herhangi bir satın alımları için kredi kartı zorunludur. Lütfen kredi kartınızı giriniz.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subbutton", on: { click: _vm.forward } }, [
          _vm._v("Devam Et"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }